var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator");

/* eslint-disable no-undef */
var resolveURL = require('resolve-url');

var _require = require('../utils/log'),
    log = _require.log;
/*
 * Fetch data from remote URL and convert to blob URL
 * to avoid CORS issue
 */


var toBlobURL = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, mimeType) {
    var buf, blob, blobURL;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log('info', "fetch ".concat(url));
            _context.next = 3;
            return fetch(url);

          case 3:
            _context.next = 5;
            return _context.sent.arrayBuffer();

          case 5:
            buf = _context.sent;
            log('info', "".concat(url, " file size = ").concat(buf.byteLength, " bytes"));
            blob = new Blob([buf], {
              type: mimeType
            });
            blobURL = URL.createObjectURL(blob);
            log('info', "".concat(url, " blob URL = ").concat(blobURL));
            return _context.abrupt("return", blobURL);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function toBlobURL(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var _corePath, coreRemotePath, corePath, wasmPath, workerPath;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _corePath = _ref2.corePath;

            if (!(typeof _corePath !== 'string')) {
              _context2.next = 3;
              break;
            }

            throw Error('corePath should be a string!');

          case 3:
            coreRemotePath = resolveURL(_corePath);
            _context2.next = 6;
            return toBlobURL(coreRemotePath, 'application/javascript');

          case 6:
            corePath = _context2.sent;
            _context2.next = 9;
            return toBlobURL(coreRemotePath.replace('ffmpeg-core.js', 'ffmpeg-core.wasm'), 'application/wasm');

          case 9:
            wasmPath = _context2.sent;
            _context2.next = 12;
            return toBlobURL(coreRemotePath.replace('ffmpeg-core.js', 'ffmpeg-core.worker.js'), 'application/javascript');

          case 12:
            workerPath = _context2.sent;

            if (!(typeof createFFmpegCore === 'undefined')) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("return", new Promise(function (resolve) {
              var script = document.createElement('script');

              var eventHandler = function eventHandler() {
                script.removeEventListener('load', eventHandler);
                log('info', 'ffmpeg-core.js script loaded');
                resolve({
                  createFFmpegCore: createFFmpegCore,
                  corePath: corePath,
                  wasmPath: wasmPath,
                  workerPath: workerPath
                });
              };

              script.src = corePath;
              script.type = 'text/javascript';
              script.addEventListener('load', eventHandler);
              document.getElementsByTagName('head')[0].appendChild(script);
            }));

          case 15:
            log('info', 'ffmpeg-core.js script is loaded already');
            return _context2.abrupt("return", Promise.resolve({
              createFFmpegCore: createFFmpegCore,
              corePath: corePath,
              wasmPath: wasmPath,
              workerPath: workerPath
            }));

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}();